export default __webpack_public_path__ + "static/kalen-ef3624a8322095f20078c5b3fc1d46de.png";